var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 120,
    viewBox: "0 0 121 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 60,
    r: 60,
    fill: "#FB5012"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63 70C63 71.3807 61.8807 72.5 60.5 72.5C59.1193 72.5 58 71.3807 58 70C58 68.6193 59.1193 67.5 60.5 67.5C61.8807 67.5 63 68.6193 63 70Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5 47.5V62.5M85.5 60C85.5 73.8071 74.3071 85 60.5 85C46.6929 85 35.5 73.8071 35.5 60C35.5 46.1929 46.6929 35 60.5 35C74.3071 35 85.5 46.1929 85.5 60Z",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIcon);
export default __webpack_public_path__ + "static/media/alert-icon.807d337d8aff3c18de427440a6943c3f.svg";
export { ForwardRef as ReactComponent };